import {Autocomplete, TextField} from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import {faX} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const SVPAutocomplete = ({
    options,
    onChange,
    value,
    footerText,
    isDisabled = false,
    isDisableInactiveOptions = false,
    isShowClearIcon = false,
}) => {
    return (
        <>
            <Autocomplete
                disablePortal={true}
                options={options}
                onChange={onChange}
                renderInput={(params) => <TextField {...params} />}
                size="small"
                value={value}
                sx={{
                    "& .MuiInputBase-root": {
                        "backgroundColor": "white",
                        "height": "37px",
                        "marginTop": "3px",
                        "borderRadius": "4px",
                        "&.Mui-disabled": {
                            backgroundColor: "#f5f5f5",
                        },
                    },
                }}
                clearIcon={isShowClearIcon && <FontAwesomeIcon icon={faX} style={{fontSize: "12px"}} />}
                disabled={isDisabled}
                getOptionDisabled={isDisableInactiveOptions ? (option) => !option.is_active : null}
            />
            {footerText}
        </>);
};

SVPAutocomplete.propTypes = {
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
    footerText: PropTypes.node,
    isDisabled: PropTypes.bool,
    isDisableInactiveOptions: PropTypes.bool,
    isShowClearIcon: PropTypes.bool,
};
